// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1RE2q","buttons":"SendReceipts_buttons__OsPfj","email":"SendReceipts_email__XsSvW","bookApptTitle":"SendReceipts_bookApptTitle__1H_dX"};